import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWebsite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWebsite"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V8H21V21ZM6.83594 14.5L9.54297 17.207L10.957 15.793L9.66406 14.5L10.957 13.207L9.54297 11.793L6.83594 14.5ZM13.043 13.207L14.3359 14.5L13.043 15.793L14.457 17.207L17.1641 14.5L14.457 11.793L13.043 13.207Z" fill="currentColor"/><Path d="M21 6H3V3H21V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWebsite;
